import React, { useEffect, useState } from 'react'
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const SelectAdditional = () => {
        const navigate = useNavigate();
        const [data , setData] = useState([]);
        const boxesData = [1,2,3,4,5,6];
    
        const goToPage = () => {
            navigate("/kyc_details");
            return
          };
    
        useEffect(()=> {
            setData(boxesData)
        },[])
    
        const fecthApi = async () => {
            try {
    
            } catch (error) {
                console.log(error)
            }
        }
  return (
    <>
          {/* <div className="header">
            <IoMdArrowBack className="back-icon" onClick={()=> navigate("/preferred_shop")}/>
            <h3 className="header-title">Select your Additional shops</h3>
          </div>
          
          <div className='searchingData'>
            <input type='text' placeholder='Search By Name/Code/Mobile' className='searchByAny'/>
            <button className='findBtn'>Search</button>
          </div>

          <div className='exrtaHeading'>
            <p>Select your Optional Shops</p>
          </div>

           <div className='shopsData'>
            {
                data.map((item,idx) => (
                <div className='classBoxes' key={idx}>
                    Data not found
                </div>
                ))
            }
           <button className='blueBtn' onClick={goToPage}>Next/Skip</button>
           </div>  */}
    </>
  )
}

export default SelectAdditional